const englishDefaultPartyNames = [
  'First Party', 'Second Party', 'Third Party', 'Fourth Party', 'Fifth Party',
  'Sixth Party', 'Seventh Party', 'Eighth Party', 'Ninth Party', 'Tenth Party',
  'Eleventh Party', 'Twelfth Party', 'Thirteenth Party', 'Fourteenth Party', 'Fifteenth Party',
  'Sixteenth Party', 'Seventeenth Party', 'Eighteenth Party', 'Nineteenth Party', 'Twentieth Party'
]

function ordinalSuffix (number) {
  const lastTwoDigits = number % 100

  if (lastTwoDigits >= 11 && lastTwoDigits <= 13) return 'th'

  return ({ 1: 'st', 2: 'nd', 3: 'rd' }[number % 10] || 'th')
}

export function partyDisplayParts (name) {
  const index = englishDefaultPartyNames.indexOf(name)

  if (index === -1) return null

  const number = index + 1

  return { number, suffix: ordinalSuffix(number), label: 'Party' }
}

export function partyDisplayName (name) {
  const parts = partyDisplayParts(name)

  if (!parts) return name

  return `${parts.number}${parts.suffix} ${parts.label}`
}
